<template>
  <div>
    <img
      src="@/assets/tarjeta_ofertas_seguro_decesos.jpg"
      style="width: 100%"
    />
    <p class="tituloTarjeta">SEGURO DE DECESOS</p>
    <p>
      Cuidar de los tuyos es lo más importante. Calcula el precio de tu seguro de decesos y gana tranquilidad.
    </p>
    <ul style="list-style-type: disc">
      <li>Toda tu familia cubierta, en todo el mundo.</li>
      <li>Defensa penal y asistencia jurídica telefónica.</li>
      <li>Asistencia por enfermedad grave repentina.</li>

    </ul>
    <p class="container-flex">
      <a href="https://www.mmtseguros.com/calcular/seguros-decesos?id_origen=c9772407e7bd0d88fcd118acb7d33c62" target="_blank">
        <button class="pure-button botonLlamar">Calcula tu precio</button>
      </a>
    </p>
  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
.divHorizontal {
  display: inline-block;
  text-align: center;
}
.divCuponAmigo {
  align-items: center;
  justify-content: center;
}
</style>
